import { useQuery } from '@sequencehq/api/utils'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'

export const useAsset = (assetId: string | undefined) => {
  return useQuery(
    dashboard20240730Client.getAsset,
    { id: assetId ?? '' },
    {
      enabled: !!assetId
    }
  )
}
